export const RIVE_BANNER_JACKPOT_KEY = 'jackpot_amount';
